import React from 'react'
import {
  DescriptionOutlined,
  NoteOutlined,
  AttachFileOutlined,
  ChatOutlined,
  VideoCallOutlined,
  AssessmentOutlined,
  BrushOutlined,
} from '@mui/icons-material'

export default function TopicTypeIcon(props: {
  topic_type: string
  color: 'primary' | 'secondary' | 'inherit' | 'action' | 'error'
  style?: React.CSSProperties
}) {
  const { topic_type, color } = props

  if (topic_type === 'topics' || topic_type === 'topic') {
    return (
      <DescriptionOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else if (topic_type === 'notes') {
    return (
      <NoteOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else if (topic_type === 'files') {
    return (
      <AttachFileOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else if (topic_type === 'discussion') {
    return (
      <ChatOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else if (topic_type === 'liveclass') {
    return (
      <VideoCallOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else if (topic_type === 'assessment') {
    return (
      <AssessmentOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else if (topic_type === 'whiteboard') {
    return (
      <BrushOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  } else {
    return (
      <DescriptionOutlined
        color={color}
        style={{ fontSize: '1rem', ...props.style }}
      />
    )
  }
}
